var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "relative rounded-md sm:text-sm sm:leading-5 bg-inherit" },
    [
      _vm.prefix
        ? _c(
            "div",
            {
              staticClass:
                "absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none",
              class: _vm.iconStyle,
            },
            [
              _vm._t("prefix", function () {
                return [
                  _vm.svgPrefix
                    ? _c("div", { staticClass: "mb-1.5 mr-1.5" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "16",
                              height: "16",
                              viewBox: "0 0 16 16",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M9.33333 7.33331H8.66667V4.66665H10C10.1768 4.66665 10.3464 4.73688 10.4714 4.86191C10.5964 4.98693 10.6667 5.1565 10.6667 5.33331C10.6667 5.51012 10.7369 5.67969 10.8619 5.80472C10.987 5.92974 11.1565 5.99998 11.3333 5.99998C11.5101 5.99998 11.6797 5.92974 11.8047 5.80472C11.9298 5.67969 12 5.51012 12 5.33331C12 4.80288 11.7893 4.29417 11.4142 3.9191C11.0391 3.54403 10.5304 3.33331 10 3.33331H8.66667V1.99998C8.66667 1.82317 8.59643 1.6536 8.4714 1.52858C8.34638 1.40355 8.17681 1.33331 8 1.33331C7.82319 1.33331 7.65362 1.40355 7.5286 1.52858C7.40357 1.6536 7.33333 1.82317 7.33333 1.99998V3.33331H6.66667C5.95942 3.33331 5.28115 3.61426 4.78105 4.11436C4.28095 4.61446 4 5.29274 4 5.99998C4 6.70722 4.28095 7.3855 4.78105 7.8856C5.28115 8.38569 5.95942 8.66665 6.66667 8.66665H7.33333V11.3333H6C5.82319 11.3333 5.65362 11.2631 5.5286 11.1381C5.40357 11.013 5.33333 10.8435 5.33333 10.6666C5.33333 10.4898 5.2631 10.3203 5.13807 10.1952C5.01305 10.0702 4.84348 9.99998 4.66667 9.99998C4.48986 9.99998 4.32029 10.0702 4.19526 10.1952C4.07024 10.3203 4 10.4898 4 10.6666C4 11.1971 4.21071 11.7058 4.58579 12.0809C4.96086 12.4559 5.46957 12.6666 6 12.6666H7.33333V14C7.33333 14.1768 7.40357 14.3464 7.5286 14.4714C7.65362 14.5964 7.82319 14.6666 8 14.6666C8.17681 14.6666 8.34638 14.5964 8.4714 14.4714C8.59643 14.3464 8.66667 14.1768 8.66667 14V12.6666H9.33333C10.0406 12.6666 10.7189 12.3857 11.219 11.8856C11.719 11.3855 12 10.7072 12 9.99998C12 9.29274 11.719 8.61446 11.219 8.11436C10.7189 7.61426 10.0406 7.33331 9.33333 7.33331ZM7.33333 7.33331H6.66667C6.31304 7.33331 5.97391 7.19284 5.72386 6.94279C5.47381 6.69274 5.33333 6.3536 5.33333 5.99998C5.33333 5.64636 5.47381 5.30722 5.72386 5.05717C5.97391 4.80712 6.31304 4.66665 6.66667 4.66665H7.33333V7.33331ZM9.33333 11.3333H8.66667V8.66665H9.33333C9.68696 8.66665 10.0261 8.80712 10.2761 9.05717C10.5262 9.30722 10.6667 9.64636 10.6667 9.99998C10.6667 10.3536 10.5262 10.6927 10.2761 10.9428C10.0261 11.1928 9.68696 11.3333 9.33333 11.3333Z",
                                fill: "#717986",
                              },
                            }),
                          ]
                        ),
                      ])
                    : _c("span", { staticClass: "text-gray-500" }, [
                        _vm._v(" " + _vm._s(_vm.prefix) + " "),
                      ]),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _c(
        "FormInput",
        _vm._g(
          _vm._b(
            {
              class: _vm.inputClasses,
              attrs: { height: _vm.height, inputClass: _vm.inputClass },
            },
            "FormInput",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
      _vm.suffix
        ? _c(
            "div",
            {
              staticClass:
                "absolute inset-y-0 right-0 pr-2 flex items-center pointer-events-none",
            },
            [
              _vm._t("suffix", function () {
                return [
                  _c("span", { staticClass: "text-gray-500" }, [
                    _vm._v(" " + _vm._s(_vm.suffix) + " "),
                  ]),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm.withIcon
        ? _c(
            "div",
            {
              staticClass: "absolute inset-y-0 right-0 pr-3 flex items-center",
            },
            [_vm._t("icon")],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }